import { objConstants } from '../constants';

export function objs(state = {}, action) {
  switch (action.type) {
    case objConstants.GETALL_REQUEST:
      return {
        items: null,
        loading: true,
        type:action.type
      };
    case objConstants.GETALL_SUCCESS:
      return {
        items: action.objs,
        loading: false,
        type:action.type
      };
    case objConstants.GETALL_FAILURE:
      return { 
        error: action.error,
        loading: false,
        items: null,
        type:action.type
      };

    case objConstants.GET_REQUEST:
      return {
        loading: true,
        type:action.type
      };
    case objConstants.GET_SUCCESS:
      return {
        item: action.obj,
        loading: false,
        type:action.type
      };
    case objConstants.GET_FAILURE:
      return { 
        loading: false,
        error: action.error,
        type:action.type
    };  
    case objConstants.DELETE_REQUEST:
      // add 'deleting:true' property to user being deleted
      return {
        ...state,
        loading: true,
        
        type:action.type,
        // items: state.items.map(obj =>
        //   obj.id === action.id
        //     ? { ...obj, loading: true }
        //     : obj
        // )
      };
    case objConstants.DELETE_SUCCESS:
      // remove deleted user from state
      console.log('del success obj',action.obj)
      return {
        // items: state.items.filter(obj => obj.id !== action.id),
        loading: false,
        item: action.obj,
        type:action.type
        

      };
    case objConstants.DELETE_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to user 
      return {
        ...state,
        loading: false,
        type:action.type,
        error:action.error
        // items: state.items.map(obj => {
        //   if (obj.id === action.id) {
        //     // make copy of user without 'deleting:true' property
        //     const { loading, ...objCopy } = obj;
        //     // return copy of user with 'deleteError:[error]' property
        //     return { ...objCopy,  deleteError: action.error,type:action.type };
        //   }

        //   return obj;
        // })
      };

    case objConstants.ADD_REQUEST:
      return { loading: true ,type:action.type};
    case objConstants.ADD_SUCCESS:
      return { loading: false,type:action.type,item: action.obj };
    case objConstants.ADD_FAILURE:
      return { loading: false,type:action.type,error:action.error };
    case objConstants.UPDATE_REQUEST:
      return { loading: true ,type:action.type};
    case objConstants.UPDATE_SUCCESS:
      return { loading: false,type:action.type,item: action.obj };
    case objConstants.UPDATE_FAILURE:
      return { loading: false,type:action.type ,error:action.error};
    
  
    default:
      return state
  }
}